import React from "react";

import clsx from "clsx";
import { motion } from "framer-motion";

interface Props {
  text?: string;
  isOpen: boolean;
  isHovering: boolean;
  butttonActiveTextClassName?: string;
  butttonTextClassName?: string;
}

export const DefaultButtonContent = ({
  text,
  isOpen,
  isHovering,
  butttonActiveTextClassName,
  butttonTextClassName,
}: Props) => (
  <>
    <span
      className={clsx(
        "mr-3 truncate",
        isHovering || isOpen
          ? butttonActiveTextClassName
          : butttonTextClassName,
      )}
    >
      {text}
    </span>
    <motion.i
      initial={false}
      animate={{ rotate: isOpen ? 0 : 180 }}
      transition={{ duration: 0.2 }}
      className={clsx("fa-regular fa-sharp fa-chevron-up text-xs", {
        "text-primary": isOpen,
      })}
    />
  </>
);
